import { render } from "./Terms.vue?vue&type=template&id=665f2ea4&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=665f2ea4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-665f2ea4"

export default script